import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import translationEn from "utils/locales/en/translation.json";
import translationPl from "utils/locales/pl/translation.json";

const resources = {
	pl: {
		translation: translationPl,
	},
	en: {
		translation: translationEn,
	},
};

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		debug: true,
		fallbackLng: "pl",

	});

export default i18n;